interface Key {
  label: string;
  onPress: () => void;
  ariaLabel?: string;
  primary?: boolean;
}

interface KeypadProps {
  onDigit: (digit: string) => void;
  /** Bottom-left key, e.g. "," for amounts or "Wissen" for codes. */
  left?: Key;
  /** Bottom-right key, e.g. ⌫ or OK. */
  right?: Key;
  disabled?: boolean;
}

const DIGITS = ["7", "8", "9", "4", "5", "6", "1", "2", "3"];

/** The touch keypad for codes and amounts, laid out like a till (7 8 9 on top). */
export function Keypad({ onDigit, left, right, disabled = false }: KeypadProps) {
  const special = (key: Key | undefined) =>
    key ? (
      <button
        type="button"
        className={key.primary === true ? "btn primary" : undefined}
        disabled={disabled}
        onClick={key.onPress}
        aria-label={key.ariaLabel}
      >
        {key.label}
      </button>
    ) : (
      <span />
    );

  return (
    <div className="pad">
      {DIGITS.map((digit) => (
        <button key={digit} type="button" disabled={disabled} onClick={() => onDigit(digit)}>
          {digit}
        </button>
      ))}
      {special(left)}
      <button type="button" disabled={disabled} onClick={() => onDigit("0")}>
        0
      </button>
      {special(right)}
    </div>
  );
}
